import { useState, useCallback, useEffect } from 'react';

let logoutTimer;

export const useAuth = () => {
	// TODO: set isLogged in value to false
	const [ token, setToken ] = useState(false);
	const [ tokenExpirationDate, setTokenExpirationDate ] = useState();
	const [ userId, setUserId ] = useState(false);

	const login = useCallback((uid, token, expirationDate) => {
		setToken(token);
		setUserId(uid);
		// set token expiration timer
		const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);
		setTokenExpirationDate(tokenExpirationDate);
		localStorage.setItem(
			'userData',
			JSON.stringify({
				userId: uid,
				token: token,
				expiration: tokenExpirationDate.toISOString()
			})
		);
	}, []);

	const logout = useCallback(() => {
		setToken(null);
		setTokenExpirationDate(null);
		setUserId(null);
		localStorage.removeItem('userData');
	}, []);

	// sets timer that logs out user after the token expires

	useEffect(
		() => {
			if (token && tokenExpirationDate) {
				const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
				logoutTimer = setTimeout(logout, remainingTime);
			} else {
				clearTimeout(logoutTimer);
			}
		},
		[ token, logout, tokenExpirationDate ]
	);

	useEffect(
		() => {
			const storedData = JSON.parse(localStorage.getItem('userData'));
			if (storedData && storedData.token && new Date(storedData.expiration) > new Date()) {
				login(storedData.userId, storedData.token, new Date(storedData.expiration));
			}
		},
		[ login ]
	);

	return { token, login, logout, userId };
};
